import { useMemo } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project-imports
import AccountSwitcher from './AccountSwitcher';
import FullScreen from './FullScreen';
import Localization from './Localization';
import MegaMenuSection from './MegaMenuSection';
import Message from './Message';
import MobileSection from './MobileSection';
import MyTasksButton from './MyTasksButton';
import Notification from './Notification';
import Profile from './Profile';
import Search from './Search';

import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';
import useAuth from 'hooks/useAuth';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';
import { canSeeMenuEntry, canSeeWhatsNew } from 'utils/roleGate';
import type { UserRole } from 'api/vektra/types';

// ==============================|| HEADER - CONTENT ||============================== //

const MEGA_MENU_ROLES: UserRole[] = ['SUPER_ADMIN', 'ADMIN'];

export default function HeaderContent() {
  const {
    state: { menuOrientation }
  } = useConfig();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const { user } = useAuth() as any;
  const canSeeMegaMenu = !!user?.role && MEGA_MENU_ROLES.includes(user.role as UserRole);
  // MENU-01 — the mobile shortcut follows the sidebar's My Tasks row, so the two cannot disagree.
  const showMyTasksButton = downLG && canSeeMenuEntry(user?.role as UserRole | undefined, 'work-orders-tasks');
  // MENU-02 — What's new is drawn for the account manager alone, on every viewport.
  const showWhatsNew = canSeeWhatsNew(user?.role as UserRole | undefined);

  const localization = useMemo(() => <Localization />, []);

  const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {!downLG && <Search />}
      {!downLG && canSeeMegaMenu && megaMenu}
      {!downLG && <AccountSwitcher />}
      {!downLG && localization}
      {downLG && <Box sx={{ width: 1, ml: 1 }} />}
      {showMyTasksButton && <MyTasksButton />}

      <Notification />
      {!downLG && <FullScreen />}
      {showWhatsNew && <Message />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
